import styled from 'styled-components'

import { BREAK_POINT_LG, BREAK_POINT_MD } from '@CSSVars/variables'

export const _DescCircleMapContainer = styled.div`
  position: relative;
  p {
    line-height: 24px;
    font-family: var(--secondary-font);
    margin-bottom: 10px;
    font-size: 14px !important;
  }
  p > strong:nth-child(1) {
    margin: 0 0 10px 0;
  }
  p > strong {
    display: inline-block;
    margin: 10px 0;
  }
  em {
    display: inline-block;
  }
  h3 {
    margin: 5px 0;
  }
  h2 {
    width: calc(100% - 356px - 24px);
    @media screen and (max-width: ${BREAK_POINT_LG}) {
      width: calc(100% - 283px - 24px);
    }
    @media screen and (max-width: ${BREAK_POINT_MD}) {
      width: 100%;
    }
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 24px;
  }
`

export const _DescriptionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
`

export const _Container = styled.div`
  position: absolute;
  top: -75px;
  right: 0;
  width: 356px;
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: 283px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _TextContainer = styled.div`
  width: calc(100% - 356px - 24px);
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    width: calc(100% - 283px - 24px);
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }

`
